const lightbox = GLightbox({
  selector: '.glightbox',
  autoplayVideos: true,
  onOpen: () => {
    setTimeout(() => {
      const video = document.querySelector('.gvideo iframe, .gvideo video');
      if (video) {
        video.setAttribute('loop', 'true');
      }
    }, 500); // Delay to ensure video is loaded
  },
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mh-scrollbar').forEach((el) => {
    new SimpleBar(el, { autoHide: false });
  });
  /* mobile menu */
  const mobileMenuTrigger = document.querySelector('#mobile-menu-trigger');
  const menuDrawer = document.querySelector('#drawer-navigation');
  const menuDrawerClose = document.querySelector('#drawer-navigation-close');
  const bgOverlay = document.querySelector('#bg-overlay');

  // Check if all elements exist before adding event listeners
  if (!mobileMenuTrigger || !menuDrawer || !menuDrawerClose || !bgOverlay) {
    console.error('One or more menu elements not found');
    return;
  }

  const toggleMenu = () => {
    menuDrawer.classList.toggle('-translate-x-full');
    document.body.classList.toggle('overflow-hidden');
    bgOverlay.classList.toggle('hidden');
  };

  mobileMenuTrigger.addEventListener('click', toggleMenu);
  menuDrawerClose.addEventListener('click', toggleMenu);
  bgOverlay.addEventListener('click', toggleMenu);
});

// JavaScript for slide-up animation effect
document.addEventListener('DOMContentLoaded', function () {
  // Get all accordion buttons
  const accordionButtons = document.querySelectorAll('.accordion-bg-header  .accordion-button');

  // Add click event listener to each button
  accordionButtons.forEach((button) => {
    button.addEventListener('click', function () {
      // Find the closest parent div that contains both the button and accordion container
      const parentDiv = this.closest('.accordion-bg-header');
      const plusIcon = this.querySelector('svg:first-of-type');
      const minusIcon = this.querySelector('svg:last-of-type');

      // Find the .show-text element within the parent div
      const showTextElement = parentDiv.querySelector('.accordion-container');

      // Toggle a class to control the visibility
      if (showTextElement.classList.contains('active')) {
        // Slide down (hide)
        showTextElement.classList.remove('active');
      } else {
        // Slide up (show)
        showTextElement.classList.add('active');
      }

      // Toggle the plus/minus icon

      if (plusIcon && minusIcon) {
        plusIcon.classList.toggle('hidden');
        minusIcon.classList.toggle('hidden');
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.testimonial-swiper');

  if (!swiperEl) {
    // console.error('Swiper element not found');
    return;
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    centeredSlides: true, // Center active slide
    centerInsufficientSlides: true, // Center slides if there are fewer than slidesPerView
    slideToClickedSlide: true, // Allow clicking on slide to navigate
    navigation: {
      nextEl: document.querySelector('.testimonial-swiper .swiper-button-next-custom'),
      prevEl: document.querySelector('.testimonial-swiper .swiper-button-prev-custom'),
    },
    pagination: {
      el: document.querySelector('.swiper-pagination-progressbar'),
      type: 'progressbar',
    },
    scrollbar: {
      el: document.querySelector('.swiper-scrollbar'),
      hide: false,
      draggable: true,
    },
    breakpoints: {
      360: { slidesPerView: 2 },
      1024: { slidesPerView: 3, loop: true, centeredSlides: false, spaceBetween: 30 },
    },
  });

  // Manually handle next/prev buttons if needed
  document
    .querySelector('.testimonial-swiper .swiper-button-next-custom')
    ?.addEventListener('click', () => swiper.slideNext());
  document
    .querySelector('.testimonial-swiper .swiper-button-prev-custom')
    ?.addEventListener('click', () => swiper.slidePrev());
});

document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.testimonial-banner-swiper');

  if (!swiperEl) {
    // console.error('Swiper element not found');
    return;
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: document.querySelector('.testimonial-banner-swiper .swiper-button-next-custom'),
      prevEl: document.querySelector('.testimonial-banner-swiper .swiper-button-prev-custom'),
    },
  });
  // Manually handle next/prev buttons if needed
  document
    .querySelector('.testimonial-banner-swiper .swiper-button-next-custom')
    ?.addEventListener('click', () => swiper.slideNext());
  document
    .querySelector('.testimonial-banner-swiper .swiper-button-prev-custom')
    ?.addEventListener('click', () => swiper.slidePrev());
});

document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.variant-swiper');

  if (!swiperEl) {
    // console.error('Swiper element not found');
    return;
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: document.querySelector('.variant-swiper .swiper-button-next-custom'),
      prevEl: document.querySelector('.variant-swiper .swiper-button-prev-custom'),
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
    },
  });
  // Manually handle next/prev buttons if needed
  document
    .querySelector('.variant-swiper .swiper-button-next-custom')
    ?.addEventListener('click', () => swiper.slideNext());
  document
    .querySelector('.variant-swiper .swiper-button-prev-custom')
    ?.addEventListener('click', () => swiper.slidePrev());
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.feature-variant-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const parent = btn.closest('.variant-options');
      const allButtons = parent.querySelectorAll('.feature-variant-btn');
      const sellingPlanId = parent.querySelector('input.product-selling-plan-id');

      // Remove 'active' from all siblings
      allButtons.forEach((b) => b.classList.remove('active'));

      // Add 'active' to clicked button
      btn.classList.add('active');

      // Update the shop-now link
      const subscriptionValue = btn.getAttribute('data-selling-plan-id');
      const subscriptionType = btn.getAttribute('data-subscription');
      sellingPlanId.value = subscriptionValue;
      sellingPlanId.setAttribute('name', subscriptionType);
    });
  });
});
